<template>
    <div class="account-page">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <div class="main_home_content">
    <div class="container">
      <div class="row">
        <div class="col-md-10 offset-md-1 pt-5 pb-5">
          <!-- Login Tab Content -->
          <div class="home-content">
            <div class="row align-items-center justify-content-center">
              <div class="col-md-7 col-lg-6">
                <h1 :style="{ marginTop: '20px' }">Treatment Plan</h1>
                <h3 :style="{ marginTop: '20px' }">
                  Streamline Patient Care with Customizable Treatment Plan
                  Templates
                </h3>
                <h5 :style="{ marginTop: '20px' }">
                  {{ main_data }} Treatment Plan Templates – Efficiency
                  and Personalization in Patient Treatment
                </h5>
                <p :style="{ marginTop: '20px' }">
                  Personalized patient care requires thoughtful planning and
                  tailored strategies. With {{ main_data }} Treatment Plan
                  Templates, healthcare practitioners can create, save, and
                  reuse customized treatment plans, making the process more
                  efficient and patient-centric. Discover how this feature can
                  enhance your medical practice.
                </p>

                <div style="margin-top: 50px;">
                  <button class="btn btn-info">Book Appointment</button>
                  <button class="btn btn-success">Department</button>
                </div>
              </div>
              <div class="col-md-12 col-lg-5">
                <img
                  src="@/assets/img/doctor_img.png"
                  class="img-fluid"
                  alt="Doccure Login"
                />
              </div>
            </div>
          </div>
          <!-- /Login Tab Content -->
        </div>
      </div>
    </div>
    <!-- Key Feature Section -->
    <div class="row">
      <div class="col-md-10 offset-md-1">
        <h2 class="first_section_heading pb-5 pt-5" align="center">
          Key Features
        </h2>
        <b-card-group deck>
          <b-card
            border-variant="dark"
            header="Create Custom Treatment Plans"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <h4>Tailor-Made Plans for Individual Needs</h4>
            <b-card-text
              >Design personalized treatment plans based on patient assessments,
              medical history, and specific requirements. Add medications,
              therapies, follow-up schedules, and more to craft a comprehensive
              plan.</b-card-text
            >
          </b-card>
          <b-card
            border-variant="dark"
            header="Save and Reuse Templates"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <h4>Efficiently Reuse Successful Strategies</h4>
            <b-card-text
              >Save successful treatment plans as templates and reuse them for
              other patients with similar needs. Modify and adjust as needed,
              ensuring each plan is aligned with individual patient
              conditions.</b-card-text
            >
          </b-card>
          <b-card
            border-variant="dark"
            header="Collaboration with Medical Team"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <h4>Collaborate and Share Insights</h4>
            <b-card-text
              >Share treatment plan templates with your medical team, fostering
              collaboration and consistency in patient care across various
              healthcare providers.</b-card-text
            >
          </b-card>
        </b-card-group>
        <b-card-group deck style="margin-top: 30px;margin-bottom: 40px;">
          <b-card
            border-variant="dark"
            header="Integration with Patient Records"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <h4>Seamless Connection with Patient Data</h4>
            <b-card-text
              >Treatment Plan Templates integrate seamlessly with patient
              records, ensuring all darkrmation is up-to-date and easily
              accessible within the patient's profile.</b-card-text
            >
          </b-card>
          <b-card
            border-variant="dark"
            header="Secure and Compliant"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <h4>Your Patient's Privacy is Our Priority</h4>
            <b-card-text
              >All treatment plans and templates are stored securely, adhering
              to industry standards and regulations, ensuring patient
              confidentiality and data integrity.</b-card-text
            >
          </b-card>
          <b-card style="border: none;"> </b-card>
        </b-card-group>
      </div>
    </div>
    <!-- Benefit Section -->
    <div class="row">
      <div class="col-md-10 offset-md-1">
        <h3
          style="text-align: center; padding-bottom: 20px; margin-top: 30px;margin-bottom: 30px;"
        >
          Why Choose Treatment Plan Templates?
        </h3>
        <b-card-group deck>
          <b-card
            border-variant="dark"
            header="Efficiency"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <b-card-text
              >Save time by reusing successful treatment strategies with
              appropriate modifications.</b-card-text
            >
          </b-card>
          <b-card
            border-variant="dark"
            header="Personalization"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <b-card-text
              >Create treatment plans that are precisely tailored to individual
              patient needs.</b-card-text
            >
          </b-card>
          <b-card
            border-variant="dark"
            header="Collaboration"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <b-card-text
              >Foster teamwork and consistency in care with shareable
              templates.</b-card-text
            >
          </b-card>
        </b-card-group>
        <b-card-group deck style="margin-top: 30px;">
          <b-card
            border-variant="dark"
            header="Integration"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <b-card-text
              >Smoothly connect treatment plans with existing patient records
              and systems.</b-card-text
            >
          </b-card>
          <b-card style="border: none;"> </b-card>
          <b-card style="border: none;"> </b-card>
        </b-card-group>
      </div>
    </div>
    <!--Call Action Section -->
    <div class="mt-5"
      style="display: flex; justify-content: center; align-items: center;"
    >
      <div
        style="width: 500px; text-align: center; margin-top: 50px; margin-bottom: 50px;"
      >
        <b-card bg-variant="info" text-variant="white" title="" style="border:1px solid black;">
          <b-card-text style="text-align: center;">
            "Enhance your medical practice with {{ main_data }} Treatment
            Plan Templates. Register today and take the first step towards
            personalized and efficient patient care!"
          </b-card-text>
          <b-button href="#" variant="dark" style="text-align: center;">
            Register Now
          </b-button>
        </b-card>
      </div>
    </div>
  </div>
    <layout-footer></layout-footer>
    </div>
    </div>
  </template>
<script>
import config from "../../services/CommonApi";
import axios from "axios";
export default {
  data() {
    return {
      main_data: "",
      config: config,
    };
  },
  mounted() {
    this.get_practitioner_profile();
  },
  methods: {

    async get_practitioner_profile() {
      var domain = window.location.hostname;

      const formdata = {
        domain: window.location.hostname,
      };
      await axios
        .get(
          "https://develop-physio.kneexpert.in/api/method/sahaj.domain.get_hospital?domain=" +
          window.location.hostname
        )
        .then((res) => {
          this.showspinner = false;
          if (res.data.status_code == 200) {
            this.main_data = res.data.data[0].brand_name
          }
          if (res.data.status_code == 404) {
            if (window.location.hostname == "physio.sahajhelp.com") {
            } else if (window.location.hostname == "physio.kneexpert.in") {
            } else if (window.location.hostname == "localhost") {
            } else if (window.location.hostname.startsWith("192.168")) {
            } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
            } else {
              window.location.href = String("https://physio.kneexpert.in");
            }
          }
          this.$swal.close();
        });
    },

  },
}
</script>


// WEBPACK FOOTER //
// src/components/kneexpert/TratementPlan.vue